import { ModelType, type UnwrappedApiServiceModelDescriptor } from "@doitintl/cmp-models";

export type DataPathToken = {
  member: string;
  memberModel: UnwrappedApiServiceModelDescriptor;
};

// TODO: this is a copy of the function from cloudflow-worker lib, use this one in both places
export function augmentDataPathWithModelTypes(
  model: UnwrappedApiServiceModelDescriptor,
  dataPath: string[]
): DataPathToken[] {
  const initialContext: {
    model: UnwrappedApiServiceModelDescriptor;
    tokens: DataPathToken[];
  } = {
    model,
    tokens: [],
  };
  if (model.type === ModelType.LIST) {
    initialContext.tokens.push({
      member: "",
      memberModel: model,
    });
    initialContext.model = model.member.model;
  }
  return dataPath.reduce(({ model, tokens }, member) => {
    let nextModel: UnwrappedApiServiceModelDescriptor;
    switch (model.type) {
      case ModelType.LIST: {
        nextModel = model.member.model;
        break;
      }
      case ModelType.STRUCTURE: {
        const currentMemberModel = model.members[member].model;
        tokens.push({
          member,
          memberModel: currentMemberModel,
        });
        nextModel = currentMemberModel.type === ModelType.LIST ? currentMemberModel.member.model : currentMemberModel;
        break;
      }
      case ModelType.MAP: {
        const currentMemberModel = model.keyMemberName === member ? model.keyMember.model : model.valueMember.model;
        tokens.push({
          member,
          memberModel: currentMemberModel,
        });
        nextModel = currentMemberModel.type === ModelType.LIST ? currentMemberModel.member.model : currentMemberModel;
        break;
      }

      default:
        nextModel = model;
    }

    return {
      tokens,
      model: nextModel,
    };
  }, initialContext).tokens;
}
